import { WidgetUiHeaderStyles } from "common/ui/WidgetUi/WidgetUi.elements";
import styled from "styled-components";
 
export interface ConfigurableLineChartWidgetProps {
  className?: string;
  gridRows?: string | number;
  gridCols?: string | number;
  colSpan?: string | number;
  rowSpan?: string | number;
}

export const WidgetLayoutContainer = styled.div`

`

export const ConfigurableChartWidgetContainer = styled.div<ConfigurableLineChartWidgetProps>`
  

  .widget-header {
    ${WidgetUiHeaderStyles};
  }
  
 
  .fetching-message {
    background-color: rgba(0,0,0,.5);
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
  }

  .widget-title {
    text-transform: capitalize;
    font-size: 1em;
  }
 
  .chart-legend {
    font-size: .9em;
  }
 
  .widget-dropdown-button {
    transition: opacity 200ms;
  }
  
  details:not([open]) summary {
    section {
      background-color: red;
    }
    .widget-dropdown-button {
      opacity: 0;
    }
  }  

  
`

export const ConfigurableLineChartWidgetCollapseContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;

  &.has-left-column {
    grid-template-columns: auto 1fr;
    &.side-col-left { grid-column: 1 / span 2; }
  }

  &.has-legend {
    grid-template-rows: auto 1fr;
  }
 
`
export const ConfigurableLineChartWidgetMain = styled.div<{ gridCols?: string, gridRows?: string, height?: string }>`
 
  position: relative;
  display: grid;
  grid-template-rows: ${({ gridRows }) => gridRows || '1fr'};
  width: 100%;
  height: ${({ height }) => height || undefined};

  .updating-data-message {
    z-index: 1;
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    display: none;
    align-items: center;
    justify-content: center;
  }

  &.is-fetching {
    .updating-data-message {
      display: flex;
    }
  }

  .chart-area {
    display: grid;
    grid-template-rows: 1fr;
  }

  &.has-legend .chart-area {
 
    height: 100%;

    .chart-legend {
      width: 100%;
    }
  }

  &:not(.flyout-view) {
    .popup-container {
      display: none;
    }
  }

  &.has-legend { 
    .chart-legend { 
      grid-row: 1; 
    }
    grid-template-rows: auto 1fr;
    display: grid;    
    grid-template-rows: auto 1fr;
    &.has-left-column,
    &.has-right-column { 
      .chart-legend { grid-column: 1 / span 2; }
      .chart-side-col { grid-row: 2; }
      .generator-axis-and-grid-wrapper-container { grid-row: 2; }
    }  
  }
  &.has-left-column { 
    grid-template-columns: auto 1fr; 
    .generator-axis-and-grid-wrapper-container { grid-column: 2;}
  }
  &.has-right-column { grid-template-columns: 1fr auto;}
  &.has-right-column.has-left-column { grid-template-columns: auto 1fr auto; }

  &.has-left-column, &.has-right-column, &.has-legend {
    display: grid;
    grid-column-gap: 1em;

    .chart-side-col {
      position: relative;
      &.left { grid-column: 1; }
      &.right { grid-column: 2; }
      .scroll-wrapper {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
      }
    }
  }

  .chart-padding-wrapper {
    position: relative;
    padding: 1em 3em 3em 4em;
    width: 100%;
    z-index: 0;
 
    .line-chart-container {
      height: 100%;
      position: relative;
    }
  }

  &.has-right-axis {
    .chart-padding-wrapper { padding-right: 4em; }
  }

  .widget-dropdown-button {
    z-index: 1;
  }

 

  .legend-item--average {
    &:before {
      background: repeating-linear-gradient(
      -45deg,
      transparent,
      transparent 3px,
      #333 3px,
      #333 5px
    );
       width: 1.75em;
       height: 1px;
       
      border-radius: 0;
    }
  }


  @media (max-width: 768px) {
    
  }

`